import { Navigate } from "react-router";

import { useBaseRoute } from "./use-base-route";

const BaseRoute = () => {
  const baseRoute = useBaseRoute();

  return <Navigate to={baseRoute} />;
};

export { BaseRoute };
